import type { ComponentProps } from "react"
import { useEffect } from "react"
import { useFormState } from "react-hook-form"
import { BusySpinner } from "@holigral/shared/ui/composed"
import { Button } from "@holigral/shared/ui/components/ui/button"

type Props = Pick<
  ComponentProps<typeof Button>,
  "children" | "disabled" | "className"
> & {
  /** Submitting is the form's one action, so this is the primary by default. */
  variant?: ComponentProps<typeof Button>["variant"]
  disabledUntilDirty?: boolean
  onDirtyChange?: (isDirty: boolean) => void
}

export default function FormSubmitButton({
  children,
  disabledUntilDirty = true,
  disabled,
  onDirtyChange,
  variant = "primary",
  ...props
}: Props) {
  const { isSubmitting, isDirty } = useFormState()

  useEffect(() => {
    onDirtyChange?.(isDirty)
  }, [isDirty, onDirtyChange])

  return (
    <Button
      type="submit"
      variant={variant}
      {...props}
      disabled={!!disabled || isSubmitting || (!isDirty && disabledUntilDirty)}
    >
      <BusySpinner busy={isSubmitting} />
      {children}
    </Button>
  )
}
